import { defineChain, getAddress, type Address } from "viem";

export const robinhoodTestnet = defineChain({
  id: 46_630,
  name: "Robinhood Chain Testnet",
  nativeCurrency: { name: "Ether", symbol: "ETH", decimals: 18 },
  rpcUrls: {
    default: { http: ["https://rpc.testnet.chain.robinhood.com"] }
  },
  blockExplorers: {
    default: {
      name: "Robinhood Explorer",
      url: "https://explorer.testnet.chain.robinhood.com"
    }
  },
  testnet: true
});

const zero = "0x0000000000000000000000000000000000000000";
function envAddress(value: string | undefined): Address {
  return getAddress(value && /^0x[0-9a-fA-F]{40}$/.test(value) ? value : zero);
}

export const config = {
  apiUrl: (import.meta.env.VITE_API_URL as string | undefined)?.replace(/\/$/, "")
    ?? "http://localhost:8787",
  contracts: {
    conditionalTokens: envAddress(import.meta.env.VITE_CONDITIONAL_TOKENS),
    fpmmFactory: envAddress(import.meta.env.VITE_FPMM_FACTORY),
    collateral: envAddress(import.meta.env.VITE_COLLATERAL),
    oracle: envAddress(import.meta.env.VITE_ORACLE),
    marketFactory: envAddress(import.meta.env.VITE_MARKET_FACTORY),
    positionLens: envAddress(import.meta.env.VITE_POSITION_LENS)
  }
};

export function contractsConfigured(): boolean {
  return Object.values(config.contracts).every((address) => address !== zero);
}
